// just a demonstration of how to customize the layout for a specific command
var t = () => {
    return `
<div class="content measure-clear-tool" id="measure-clear-tool"></div>
`;
}

export = t;    